export default function Market() {
  return (
    <section className="py-32 bg-gradient-to-b from-[#2A2318] to-[#231D17]">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#E5C478] mb-16 text-center tracking-wide">
            Market Opportunity
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative h-96 rounded-lg overflow-hidden shadow-2xl order-2 md:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/fe74f20a8d5e6860ac070e4e4f247e95.jpg"
                alt="Premium Padel Facility"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="space-y-8 order-1 md:order-2">
              <p className="text-lg md:text-xl text-[#F0E1C2]/90 leading-relaxed">
                The rapid growth of padel in the UK, combined with limited high-end indoor facilities, creates a strong opportunity for a differentiated and scalable premium concept.
              </p>

              <div className="w-20 h-1 bg-[#B78A44]"></div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-3 h-3 bg-[#B78A44] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base text-[#F0E1C2]/80 leading-relaxed">
                    <strong className="text-[#E5C478]">Growing Demand:</strong> Padel participation continues to surge across the United Kingdom and Europe.
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-3 h-3 bg-[#B78A44] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base text-[#F0E1C2]/80 leading-relaxed">
                    <strong className="text-[#E5C478]">Premium Positioning:</strong> A focus on quality and experience differentiates The GodPadel™ from volume-driven competitors.
                  </p>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-3 h-3 bg-[#B78A44] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-base text-[#F0E1C2]/80 leading-relaxed">
                    <strong className="text-[#E5C478]">Scalable Concept:</strong> Built to expand while maintaining the integrity and exclusivity of the brand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
